const initialState = {
    isOpen: false,
    factorNum: '',
    transNum: 0,
    transKey: 0, // indexe marbut be tarakoneshha
};
const modalEditTransFactorNum = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_EDIT_TRANS_FACTOR_NUM':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalEditTransFactorNum;
